import React from "react";
import { Tooltip } from "antd";
import { combineClasses } from "../../../../../lib/utils/combineClasses";
import { ViewModeType } from "../../../../../lib/types";
import { ReactComponent as SubmitButtonIcon } from "../../../../../img/buttons_icons/submitButton_icon.svg";
import { ReactComponent as CancelButtonIcon } from "../../../../../img/buttons_icons/cancelButton_icon.svg";
import { ReactComponent as AddVersionIcon } from "../../../../../img/versions_icons/addVersion_icon.svg";
import { ReactComponent as CloseVersionIcon } from "../../../../../img/versions_icons/closeVersion_icon.svg";
import { ReactComponent as EditIcon } from "../../../../../img/versions_icons/editVersion_icon.svg";
import "./AggregationRulePageButtons.less";

interface ComponentProps {
  className?: string;
  viewMode: ViewModeType;
  setViewMode: (viewMode: ViewModeType) => void;
  // isPastVersion: boolean;
  // isLatestVersion: boolean;
  handleSubmitUpdate: (force: boolean) => void;
  handleSubmitClose: () => void;
  priceCreationAllowed: boolean;
  hadleCancelEdit: () => void;
}

export const AggregationRulePageButtons = (props: ComponentProps) => {
  const {
    className,
    viewMode,
    // isPastVersion,
    // isLatestVersion,
    setViewMode,
    handleSubmitUpdate,
    handleSubmitClose,
    priceCreationAllowed,
    hadleCancelEdit,
  } = props;

  return (
    <div className={combineClasses("aggregationRule-pageButtons", className)}>
      {viewMode === "view" && (
        <>
          {/* {!isPastVersion && ( */}
          <>
            {/* {priceCreationAllowed && isLatestVersion && ( */}
            {priceCreationAllowed && (
              <Tooltip title="Добавить версию">
                <AddVersionIcon
                  onClick={() => {
                    setViewMode("addVersion");
                  }}
                  className="aggregationRule-pageButtons__iconBtn"
                />
              </Tooltip>
            )}

            {priceCreationAllowed && (
              <Tooltip title="Редактировать">
                <EditIcon
                  onClick={() => {
                    setViewMode("edit");
                  }}
                  className="aggregationRule-pageButtons__iconBtn"
                />
              </Tooltip>
            )}

            {/* {priceCreationAllowed && isLatestVersion && ( */}
            {priceCreationAllowed && (
              <Tooltip title="Изменить дату закрытия">
                <CloseVersionIcon
                  onClick={() => {
                    setViewMode("close");
                  }}
                  className="aggregationRule-pageButtons__iconBtn"
                />
              </Tooltip>
            )}
          </>
          {/* )} */}

          {/* <Tooltip title="Удалить">
            <DeleteIcon
              // onClick={handleOnDeleteConfirmModal}
              className="aggregationRule-pageButtons__iconBtn"
            />
          </Tooltip> */}
        </>
      )}
      {viewMode === "edit" && (
        <Tooltip title="Сохранить изменения">
          <SubmitButtonIcon
            onClick={() => {
              handleSubmitUpdate(true);
            }}
            className="aggregationRule-pageButtons__iconBtn"
          />
        </Tooltip>
      )}
      {viewMode === "addVersion" && (
        <Tooltip title="Сохранить изменения">
          <SubmitButtonIcon
            onClick={() => {
              handleSubmitUpdate(false);
            }}
            className="aggregationRule-pageButtons__iconBtn"
          />
        </Tooltip>
      )}
      {viewMode === "close" && (
        <Tooltip title="Сохранить изменения">
          <SubmitButtonIcon
            onClick={handleSubmitClose}
            className="aggregationRule-pageButtons__iconBtn"
          />
        </Tooltip>
      )}
      {["edit", "close", "addVersion"].includes(viewMode) && (
        <Tooltip title="Отменить">
          <CancelButtonIcon
            onClick={() => {
              hadleCancelEdit();
            }}
            className="aggregationRule-pageButtons__iconBtn"
          />
        </Tooltip>
      )}
    </div>
  );
};
